import { render, staticRenderFns } from "./AdvertisersPage.vue?vue&type=template&id=dcff0990&"
import script from "./AdvertisersPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports